import { useTheme } from '@mui/system';
import React from 'react';

const skillsBars = [
    { skill: 'Stock picking', x: 74 },
    { skill: 'Sizing', x: -42 },
    { skill: 'Entry timing', x: -27 },
    { skill: 'Scaling in', x: 61 },
    { skill: 'Size adjusting', x: 47 },
    { skill: 'Scaling out', x: -42 },
    { skill: 'Exit timing', x: 39 }
];

/**
 * Renders a preview of the Insight Pro Breakdown by Skill bar chart as an SVG.
 * @component
 * @returns {React.Element}
 */
export const SkillsBarChartShowcase = () => {
    const theme = useTheme();

    return (
        <svg
            width='274'
            height='236'
            viewBox='0 0 274 236'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                width='100%'
                height='100%'
                rx='9.75'
                fill={theme.palette.common.white}
            />
            {skillsBars.map((item, index) => {
                return (
                    <React.Fragment key={item.skill}>
                        <text
                            x={18}
                            y={29 * (index + 1) + 4}
                            style={{
                                fill: theme.palette.abbey.lightest,
                                fontWeight: 700,
                                fontSize: '10px'
                            }}
                        >
                            {item.skill}
                        </text>
                        <rect
                            x={item.x > 0 ? 187 : 187 + item.x}
                            y={29 * (index + 1) - 9}
                            height={20}
                            width={Math.abs(item.x)}
                            fill={
                                theme.palette.scatterPlot.barColors[item.skill]
                            }
                        />
                    </React.Fragment>
                );
            })}
        </svg>
    );
};
